/**
 * Соответствие латиницы (логин) → кириллица (ФИО) для отображения в отчётах и модалках.
 * Используется в «Отчет активности локальных ПК» и в модалке «Подробности».
 */
export const LATIN_TO_CYRILLIC_FIO = {
  Valentina_Bulgakova: 'Валентина Булгакова',
  Irina_Pluhina: 'Ирина Плюхина',
  Marina_Tolokolnikova: 'Толокольникова',
  Marina_Mamrockaya: 'Марина Мамроцкая',
  Svetlana_Shvec: 'Светлана Швец',
  Anna_Zaitseva: 'Анна Зайцева',
  Alina_Sivokon: 'Алина Сивоконь',
  Svetlana_Nedomovnaya: 'Светлана Недомовная',
  Anna_Danko: 'Анна Данько',
  Anna_Marchenko: 'Анна Марченко',
  Ekaterina_Krivoruchko: 'Екатерина Криворучко',
  Luba_Kozlovskaya: 'Люба Козловская',
  Alexandra_cushko: 'Александра Цушко',
  Vlad_Levkovsky: 'Владислав Левковский',
  Inna_Mulyar: 'Инна Муляр',
  Tatiana_Linenko: 'Татьяна Линенко',
  Alexandra_Rogko: 'Александра Рожко',
  Violetta_Ryabchuk: 'Виолетта Рябчук',
  Ivan_Porchak: 'Иван Порчак',
  Valentina_Bondarenko: 'Валентина Бондаренко',
  Ulia_Pshenichkina: 'Юлия Пшеничкина',
  Tatyana_Karpov: 'Татьяна Карпов',
  tatyana_karpov: 'Татьяна Карпов',
  Irina_Chumak: 'Ирина Чумак',
  irina_chumak: 'Ирина Чумак',
  Andrei_Ismailov: 'Андрей Исмаилов',
  Sergei_Sorokopud: 'Сергей Сорокопуд',
  Pavel_Eremeev: 'Павел Еремеев',
  Konstantin_Denisenko: 'Константин Денисенко',
  Violetta_Peshko: 'Виола Пешко',
  Nikolay_Bodnar: 'Николай Боднар',
  Snegana_Bodnar: 'Снежана Накемпий',
  Tatiana_Ryabenko: 'Татьяна Рябенко',
  Ekaterina_Gorecka: 'Катерина Горецька'
};

/** Список латинских логинов для сравнения посещаемости (один ключ на человека, без дублей регистра). */
export const EXPECTED_EMPLOYEES_FOR_ATTENDANCE = [
  'Valentina_Bulgakova',
  'Irina_Pluhina',
  'Marina_Tolokolnikova',
  'Marina_Mamrockaya',
  'Svetlana_Shvec',
  'Anna_Zaitseva',
  'Anastasiya_Murcita',
  'Alina_Sivokon',
  'Svetlana_Nedomovnaya',
  'Anna_Danko',
  'Anna_Marchenko',
  'Ekaterina_Krivoruchko',
  'Luba_Kozlovskaya',
  'Alexandra_cushko',
  'Vlad_Levkovsky',
  'Inna_Mulyar',
  'Tatiana_Linenko',
  'Alexandra_Rogko',
  'Violetta_Ryabchuk',
  'Ivan_Porchak',
  'Valentina_Bondarenko',
  'Ulia_Pshenichkina',
  'Tatyana_Karpov',
  'Irina_Chumak',
  'Andrei_Ismailov',
  'Sergei_Sorokopud',
  'Pavel_Eremeev',
  'Konstantin_Denisenko',
  'Violetta_Peshko',
  'Nikolay_Bodnar',
  'Snegana_Bodnar',
  'Tatiana_Ryabenko',
  'Ekaterina_Gorecka'
];

/**
 * Возвращает кириллическое ФИО для отображения или исходную строку, если соответствия нет.
 * @param {string} latin - логин/ФИО на латинице
 * @returns {string}
 */
export function toCyrillicFio(latin) {
  if (!latin || typeof latin !== 'string') return latin;
  const t = latin.trim();
  if (LATIN_TO_CYRILLIC_FIO[t]) return LATIN_TO_CYRILLIC_FIO[t];
  const withUnderscore = t.replace(/\s+/g, '_');
  if (LATIN_TO_CYRILLIC_FIO[withUnderscore]) return LATIN_TO_CYRILLIC_FIO[withUnderscore];
  const lower = t.toLowerCase();
  for (const k of Object.keys(LATIN_TO_CYRILLIC_FIO)) {
    if (k.toLowerCase() === lower) return LATIN_TO_CYRILLIC_FIO[k];
  }
  return latin;
}

function resolveLocalReportDisplayName(user, resolveFio) {
  const latin = (user?.fio || user?.username || '').trim();
  if (!latin) return '';
  return typeof resolveFio === 'function' ? resolveFio(latin) : toCyrillicFio(latin);
}

/** Поиск по латинскому логину и кириллическому ФИО из таблицы. */
export function matchesLocalReportSearch(user, searchTerm, resolveFio) {
  const search = String(searchTerm || '').trim().toLowerCase();
  if (!search) return true;
  const latin = (user?.fio || user?.username || '').trim().toLowerCase();
  const display = resolveLocalReportDisplayName(user, resolveFio).toLowerCase();
  return latin.includes(search) || display.includes(search);
}

/** Подписи для автодополнения: кириллическое ФИО + латинский логин. */
export function localReportSearchLabels(users, resolveFio) {
  const seen = new Set();
  const labels = [];
  (users || []).forEach((user) => {
    const latin = (user?.fio || user?.username || '').trim();
    if (!latin) return;
    const display = resolveLocalReportDisplayName(user, resolveFio);
    [display, latin].forEach((label) => {
      const key = label.toLowerCase();
      if (label && !seen.has(key)) {
        seen.add(key);
        labels.push(label);
      }
    });
  });
  return labels.sort((a, b) => a.localeCompare(b, 'ru'));
}
